import React, {useEffect, useRef} from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import {useNavigate} from 'react-router-dom';
import RangeSlider from 'react-bootstrap-range-slider';
import axios from "axios";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import PopoverBody from 'react-bootstrap/PopoverBody';
import PopoverHeader from 'react-bootstrap/PopoverHeader';

// Images
import loader from './spinner.gif';
import info from './info.png';
import helpImg from './help-bubbles.jpg';

if (typeof Highcharts === 'object')
	HighchartsMore(Highcharts);
else
	console.log("Highcharts är inte ett objekt");

var _loading = true;

const monthNames = ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"];


function Bubbles() {
	const chartRef = useRef();	
	const [sectors, setSectors] = React.useState([]);
	const options = {
			
		chart: {
	        type: 'bubble',
	        backgroundColor: '#121212',
	        
	        animation: {
		        duration: 2000,
		        easing: 'easeInOutQuint'	        
	        }
	    },
	    
	    title: {
	      text: '',
	      style: {
	      	color: 'white',
		  	fontWeight: 'bold',
		  	fontSize: 200,
		  	opacity: 0.1
	
	      },
	      align: 'center',
	      verticalAlign: 'middle'
	    },	         
	    
	    plotOptions: {
	        bubble: {
	            minSize: 20,
	            maxSize: 120
	        }
	    },
	    
		accessibility: {
			enabled: false
		},
	        
		// Hide stuff   
	    legend: {
			enabled: false    
	    },
	    xAxis: {
			visible: false	
	    },
	    yAxis: {
			visible: false		
	    },
	    credits: {
	        enabled: false
	    },
	    tooltip: {
	        enabled: false
	    },    
	    // End hide
	
	    series: [{
		    
	        dataLabels: {
	            enabled: true,
	            format: '{point.id}',
	            color: 'white',
				textOutline: '0px',
				allowOverlap: true,
	            opacity: '10%',
				style: {
			   		fontSize: 9
				}            
	        },
	        
	        animation: {
		        duration: 2000,
		        easing: 'easeInOutQuint'	        
	        },
	
		    point: {
			    events: {
					click: function(e) {
						console.log("click:", e.point.id);
						_loading = true;
						handleClick(e.point.id);
	                }
	            }
			}
	                        
	    }]
	}		
		
	const navigate = useNavigate();
	
	const WeekSlider = () => {
		const [ value, setValue ] = React.useState(sectors.length-1);
		
		return (
			<RangeSlider
				value={value}
				onChange={e => setValue(e.target.value)}
				onAfterChange={e => displayData(chartRef.current.chart, e.target.value)}
				tooltipLabel={value => getTitle(value)}
				size='lg'
				tooltip='auto'
	            variant='info'					
				min={0}
				max={sectors.length-1} 
				inputProps={{ style: { backgroundColor: '#121212', borderColor: '#121212', margin: 0} }}
			/>
		);
	
	};	
	
	const getTitle = (value) => {
		var d = sectors[value][0].date;
		var dd = new Date(d);
									
		return d.substr(d.length - 2) + ' ' + monthNames[dd.getMonth()];
	}
	
	const displayData = (chart, i) => {
		var copyOfSectors = JSON.parse(JSON.stringify(sectors[i][1]));		
									
		chart.setTitle({text: getTitle(i)}, { text: ''}, false);			
		chart.series[0].setData(copyOfSectors);	
	}
	
	const handleClick = (id) => navigate('/stocks', {state: { detail: id }});

	const setIntervalImmediately = (func, interval) => {
		func();
		return setInterval(func, interval);
	}
 
 
 	const getSectors = async () => {	
	    var url = "http://155.4.97.54:3000/sectors";
	    
	    try {
		    var series = [];
		    
		 	const response = await axios.get(url);
		 	console.log("response.data", response.data);		 	

		 	series = response.data.reverse();
		 	setSectors(series);		    
	    } catch (error) {
		    console.log("Err: getSectors:", error);
	    }	 	
	}
	

	const afterChartCreated = (chart) => {
		displayData(chart, sectors.length-1);
	}   
	
	 
	useEffect(() => {
		
		console.log("useEffect");
		
        setIntervalImmediately(function () {
	        
			getSectors().then(() => {
				console.log("getSectors klar:", sectors.length);
				_loading = false;	     				
			})
   
				  		
        }, 1000 * 60 * 60 * 24); // Uppdatera en gång om dygnet
	    
    }, []);
        

    const renderGraphs = () => {
	    
		const renderHelp = (props) => (
			<Popover id="popover-basic" {...props}>
				<PopoverHeader as="h3">Help</PopoverHeader>
				<PopoverBody><Image className="helpImg" src={helpImg}/></PopoverBody>
			</Popover>
		);	    
	    	    
        return (
            <>				
	        <Container fluid id="chartContainer">
	        	<Row>
					<Col id="imageContainer" md="auto" style={{ padding: 10}}>
						<OverlayTrigger placement="bottom" trigger="click" overlay={renderHelp}>
							<Image className="info" src={info}/>
						</OverlayTrigger>						
					</Col>
					<Col><WeekSlider/></Col>
				</Row>		
				
				<Row id="chartRow">
					<Col>
						<HighchartsReact containerProps={{ style: { height: '100%' } }} highcharts={Highcharts} options={options} callback={afterChartCreated} ref={chartRef}/>
					</Col>
				</Row>								
				
	        </Container>
			</>
	        
        );
    }


    var imgStyle = {marginLeft: 'auto', marginRight: 'auto', display: 'block'};
            
    if (_loading) {
        console.log("laddar...");
		return (<div id="loaderDiv" style={{position:'absolute', width:'100%', height:'100%', backgroundColor: 'black'}}><img style={imgStyle} src={loader} alt=''></img></div>)
	}	    
    else {
        console.log("laddat klart, visar bubblor");
        console.log("sectors", sectors);
        return (
            <div id="container">
				{renderGraphs()}
            </div>		        
        )
    }
        
};

export default Bubbles;
